// extracted by mini-css-extract-plugin
export default {"disconnect_container":"S2_Disconnected_disconnect_container__q4KDQ","disconnect_text":"S2_Disconnected_disconnect_text__b9iYS"};